import { Form } from 'components/organisms';
import { FormikHelpers } from 'formik';
import { useParamId } from 'hooks/useParamId';
import { useNavigate } from 'react-router-dom';
import { usePostThread } from 'services/chat';
import { ICreateThread, THREAD_STATUS } from 'services/chat/types';
import { onErrorShowAllErrorsToast } from 'utils/service/errorHandler';

const CreateThread = () => {
  const labelId = useParamId('id');
  const navigate = useNavigate();

  const createThread = usePostThread();

  const onCreateThread = async (
    values: ICreateThread,
    formikHelpers: FormikHelpers<ICreateThread>,
  ) =>
    await createThread.mutateAsync(values, {
      onSuccess: data =>
        navigate(`/label/${labelId}/threads/${data.messageThreadId}`),
      onError: error => onErrorShowAllErrorsToast(error),
    });

  return (
    <Form.Support
      status={THREAD_STATUS.open}
      labelId={labelId}
      initialValues={{
        subject: '',
        message: '',
        attachments: [],
        recipientId: labelId,
      }}
      isPending={createThread.isPending}
      onSubmit={onCreateThread}
    />
  );
};

export default CreateThread;
